if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    // NativeDSD: on phones and tablets the footer menus are an accordion: only the first one starts open (the
    // "open by default" block setting no longer decides this), and opening one closes the others
    isFirstInFooter() {
      const footer = this.closest('.footer__top') || document;
      return footer.querySelector('details[is="footer-details"]') === this;
    }

    handleAfterToggle() {
      if (!this.isOpen || !FoxTheme.config.mqlTablet) return;
      const footer = this.closest('.footer__top') || document;
      footer.querySelectorAll('details[is="footer-details"]').forEach((other) => {
        if (other !== this && other.open) other.open = false;
      });
    }

    connectedCallback() {
      if (FoxTheme.config.mqlTablet) {
        if (!this.isFirstInFooter()) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        this.open = this.isFirstInFooter();
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
